import { IconSvg } from '../../types'

export const Circle: IconSvg = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...props}>
    <circle cx="12" cy="12" r="9" strokeWidth="2" />
  </svg>
)
